import { z } from 'zod';
import { SPORT_IDS } from '../sports/index';

export const SportIdSchema = z.enum(SPORT_IDS as [string, ...string[]]);

export const OrgSportPrefsSchema = z.object({
  selectedSport: SportIdSchema.nullable(),
});

export const UserPreferencesSchema = z.object({
  selectedOrgId: z.string().uuid().nullable(),
  orgPrefs: z.record(z.string().uuid(), OrgSportPrefsSchema),
  // Sport filter that applies in "All clubs" mode (no specific club active).
  // Persisted so the user's choice in the cross-club header survives reloads.
  globalSport: SportIdSchema.nullable(),
}).partial();

export const UserPreferencesPatchSchema = UserPreferencesSchema;

export type UserPreferences = z.infer<typeof UserPreferencesSchema>;
export type OrgSportPrefs = z.infer<typeof OrgSportPrefsSchema>;

export const EMPTY_USER_PREFERENCES: UserPreferences = {};
